import { ActionIcon, Group, Text } from "@mantine/core";
import { IconPencil } from "@tabler/icons-react";
import dayjs from "dayjs";

type PatientBannerProps = {
  patient?: {
    firstName: string;
    lastName: string;
    birthDate?: Date | null;
    sex?: string | null;
  } | null;
  reference: string;
  onEdit: () => void;
};

const getSexLabel = (sex?: string | null) => {
  switch (sex) {
    case "FEMALE":
      return "Femme";
    case "MALE":
      return "Homme";
    default:
      return null;
  }
};

const getAgeLabel = (birthDate?: Date | null) =>
  birthDate ? `${dayjs().diff(dayjs(birthDate), "year")} ans` : null;

export const PatientBanner = (props: PatientBannerProps) => {
  const details = [
    getSexLabel(props.patient?.sex),
    getAgeLabel(props.patient?.birthDate),
  ].filter(Boolean);

  return (
    <Group py="s4" px="s8" w="100%" bg="cardBackground">
      <Text fz="h5" fw={600} c="ink.9">
        {props.patient
          ? `${props.patient.firstName} ${props.patient.lastName}`
          : "Patient non renseigné"}
      </Text>
      <Text fz="h5" c="ink.5">
        <Text span inherit ff="monospace" fw={600} c="ink.6">
          {props.reference}
        </Text>
        {details.map(detail => ` · ${detail}`).join("")}
      </Text>
      <ActionIcon
        variant="default"
        size={26}
        c="ink.5"
        aria-label="Modifier le patient"
        title="Modifier le patient"
        onClick={props.onEdit}
      >
        <IconPencil size={13} />
      </ActionIcon>
    </Group>
  );
};
